export interface IPageLike {
    number?: number;
    pageNumber?: number;
    totalPages?: number;
    hasNextPage?: boolean;
}

export interface BillyPaginatedData<T> {
    elements: T[];
    page?: IPageLike;
}

export const resolveBillyPaginatedData = <T>(response: unknown): BillyPaginatedData<T> => {
    const normalized = (response as any)?.data?.data
        || (response as any)?.data
        || response
        || {};

    return {
        elements: (normalized?.elements || []) as T[],
        page: normalized?.page as IPageLike | undefined,
    };
};

export const resolveBillyHasMore = (
    page: IPageLike | undefined,
    incomingRowsLength: number,
    pageSize: number,
) => {
    if (typeof page?.hasNextPage === 'boolean') {
        return page.hasNextPage;
    }

    if (typeof page?.number === 'number' && typeof page?.totalPages === 'number') {
        return page.number < page.totalPages;
    }

    if (typeof page?.pageNumber === 'number' && typeof page?.totalPages === 'number') {
        return page.pageNumber < page.totalPages;
    }

    return incomingRowsLength >= pageSize;
};
